module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_northern-cyprus-d79904166270ae7147e424e410b8f44e.png";